import ProductTable from "../../components/list/ProductTable";
import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance"; // مسیر فایل axiosInstance

import Modal from "../../components/modal/Modal";

import ProductForm from "../../components/form/ProductForm";

// import ProductTable from "../../components/list/ProductTable";
// import { useEffect, useState } from "react";
// import axios from "../../utils/axiosInstance";
// import ProductModal from "../../components/modal/ProductModal";

const ProductPage = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [ShowProduct, setShowProduct] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  // const [summaryModalOpen, setSummaryModalOpen] = useState(false);

  // دریافت محصولات و دسته‌بندی‌ها
  const fetchData = async () => {
    try {
      setLoading(true);
      const [productRes, categoryRes, brandRes] = await Promise.all([
        axios.get("/products?limit=1000"),
        axios.get("/categories/leaves"),
        axios.get("/brands"),
      ]);
      // console.log("brands=", brandRes.data);
        //  console.log("productRes:", productRes);
      setProducts(productRes.data.products);
      setCategories(categoryRes.data.leafCategories);
      setBrands(brandRes.data.data);
    } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error Loading data!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  // const handleAddClick = () => {
  //   setEditingProduct(null);
  //   setModalOpen(true);
  // };

  // const handleEdit = (category) => {
  //   setEditingProduct(category);
  //   setModalOpen(true);
  // };
  // const getbrand = (brand) => {
  //   console.log("brand=", brand);
  // };
  // کلیک روی دکمه "افزودن محصول"
  const handleAddProduct = () => {
    setEditingProduct(null);
    setModalOpen(true);
  };
  // const handleSaveProduct = () => {
  //   alert("✔️ محصول با موفقیت ذخیره شد");
  //   fetchData();
  //   setModalOpen(false);
  // };

  // // کلیک روی دکمه "ویرایش"
  const handleEditProduct = (product) => {
    // console.log("brand=", brands);
    setEditingProduct(product);
    setModalOpen(true);
  };
  const handleShowProduct = (product) => {
    setModalOpen(false);
    setShowProduct(product);
    setEditingProduct(null);
    // setSummaryModalOpen(true);
  };
  // حذف محصول
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        await axios.delete(`/products/${id}`);
        setProducts((prev) => prev.filter((p) => p._id !== id));
      } catch (error) {
        console.error("❌ Error deleting product:", error);
      }
    }
  };

  // بعد از ثبت یا ویرایش محصول، لیست دوباره گرفته شود
  const handleAfterSubmit = () => {
    fetchData();
    setModalOpen(false);
    alert("✔️ Product saved successfully!");
  };

  if (loading) return <div className="p-3">⏳Loading...</div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-4">Modify Product</h4>

        <button
          onClick={handleAddProduct}
          className="btn btn-sm btn-outline-primary m-2"
        >
          Add
        </button>
      </div>
      <ProductTable
        products={products}
        onShow={handleShowProduct}
        categories={categories}
        onEdit={handleEditProduct}
        onDelete={handleDelete}
        brands={brands}
        onClose={() => setModalOpen(false)}
      />

      <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
        <ProductForm
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          product={editingProduct}
          categories={categories}
          brands={brands}
          onSuccess={handleAfterSubmit}
        />
      </Modal>
      {/* 
<Modal
  show={summaryModalOpen}
  modalClosed={() => setSummaryModalOpen(false)}
>
  <ProductSummary
    product={ShowProduct}
    onClose={() => setSummaryModalOpen(false)}
  />
</Modal> */}
    </div>
  );
};

export default ProductPage;

// const ProductPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]); // ✅ به‌جای null، یه آرایه خالی بده
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // const [productRes, categoryRes] = await Promise.all([
//         //   axios.get("/products"),

//         //   axios.get("/categories"),
//         // ]);
//         setLoading(true);
//         const productRes = await axios.get("/products?limit=1000");
//         const categoryRes = await axios.get("/categories");
//         // console.log(categoryRes.data); // این رو چاپ کن ببین چی برمی‌گرده
//         const fetchedProducts = productRes.data.products;
//         const fetchedCategories = categoryRes.data.data;
//         setProducts(fetchedProducts);
//         // console.log("productRes", productRes.data.products);
//         //   console.log("products", products);
//         setCategories(fetchedCategories);
//         // console.log("categoryRes", categoryRes.data.data);
//         // console.log("categories", categories);
//       } catch (err) {
//         console.error("❌ خطا در دریافت داده‌ها:", err);
//       } finally {
//         setLoading(false);
//         // console.log("categoriesبثفز", categories);
//       }
//     };

//     fetchData();
//   }, []);
//   const handleAddProduct = () => {
//     setEditingProduct(null); // یعنی داریم محصول جدید اضافه می‌کنیم
//     setIsModalOpen(true);
//   };

//   const handleEditProduct = (product) => {
//     setEditingProduct(product); // محصول رو برای ویرایش می‌فرستیم
//     setIsModalOpen(true);
//   };

//   // ویرایش محصول
//   const handleEdit = (product) => {
//     console.log("✏️ ویرایش محصول:", product);
//     // TODO: باز کردن مودال یا فرم
//   };

//   // حذف محصول
//   const handleDelete = async (id) => {
//     if (window.confirm("آیا مطمئنی که می‌خوای این محصول رو حذف کنی؟")) {
//       try {
//         await axios.delete(`/products/${id}`);
//         setProducts((prev) => prev.filter((p) => p._id !== id));
//       } catch (error) {
//         console.error("❌ خطا در حذف محصول:", error);
//       }
//     }
//   };
//   if (loading) return <div className="p-3">⏳ در حال بارگذاری...</div>;

//   // حالت خطا
//   if (error) return <div className="p-3 text-danger">{error}</div>;

//   // اطمینان از اینکه داده‌ها واقعاً آماده‌ان
//   if (!products || !categories) return null;

//   return (
//     <div className="p-3">
//       <h4 className="mb-4">مدیریت محصولات</h4>
//       <button onClick={() => setShowModal(true)}>افزودن محصول</button>
//       <ProductTable
//         products={products}
//         categories={categories}
//         onEdit={() => handleEditProduct(products)}
//         onDelete={handleDelete}
//       />

//       <ProductModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         product={editingProduct}
//       />
//     </div>
//   );
// };

// export default ProductPage;
// import ProductTable from "../../components/list/ProductTable";
// import { useEffect, useState } from "react";
// import axios from "../../utils/axiosInstance"; // مسیر فایل axiosInstance
// import ProductModal from "../../components/modal/ProductModal";

// const ProductPage = () => {
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]); // ✅ به‌جای null، یه آرایه خالی بده
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // const [productRes, categoryRes] = await Promise.all([
//         //   axios.get("/products"),

//         //   axios.get("/categories"),
//         // ]);
//         setLoading(true);
//         const productRes = await axios.get("/products?limit=1000");
//         const categoryRes = await axios.get("/categories");
//         // console.log(categoryRes.data); // این رو چاپ کن ببین چی برمی‌گرده
//         const fetchedProducts = productRes.data.products;
//         const fetchedCategories = categoryRes.data.data;
//         setProducts(fetchedProducts);
//         // console.log("productRes", productRes.data.products);
//         //   console.log("products", products);
//         setCategories(fetchedCategories);
//         // console.log("categoryRes", categoryRes.data.data);
//         // console.log("categories", categories);
//       } catch (err) {
//         console.error("❌ خطا در دریافت داده‌ها:", err);
//       } finally {
//         setLoading(false);
//         // console.log("categoriesبثفز", categories);
//       }
//     };

//     fetchData();
//   }, []);
//   const handleAddProduct = () => {
//     setEditingProduct(null); // یعنی داریم محصول جدید اضافه می‌کنیم
//     setIsModalOpen(true);
//   };

//   const handleEditProduct = (product) => {
//     setEditingProduct(product); // محصول رو برای ویرایش می‌فرستیم
//     setIsModalOpen(true);
//   };

//   // ویرایش محصول
//   const handleEdit = (product) => {
//     console.log("✏️ ویرایش محصول:", product);
//     // TODO: باز کردن مودال یا فرم
//   };

//   // حذف محصول
//   const handleDelete = async (id) => {
//     if (window.confirm("آیا مطمئنی که می‌خوای این محصول رو حذف کنی؟")) {
//       try {
//         await axios.delete(`/products/${id}`);
//         setProducts((prev) => prev.filter((p) => p._id !== id));
//       } catch (error) {
//         console.error("❌ خطا در حذف محصول:", error);
//       }
//     }
//   };
//   if (loading) return <div className="p-3">⏳ در حال بارگذاری...</div>;

//   // حالت خطا
//   if (error) return <div className="p-3 text-danger">{error}</div>;

//   // اطمینان از اینکه داده‌ها واقعاً آماده‌ان
//   if (!products || !categories) return null;

//   return (
//     <div className="p-3">
//       <h4 className="mb-4">مدیریت محصولات</h4>
//       <button onClick={() => setShowModal(true)}>افزودن محصول</button>
//       <ProductTable
//         products={products}
//         categories={categories}
//         onEdit={() => handleEditProduct(products)}
//         onDelete={handleDelete}
//       />

//       <ProductModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         product={editingProduct}
//       />
//     </div>
//   );
// };

// export default ProductPage;
